import { render, staticRenderFns } from "./voteIcon.vue?vue&type=template&id=3a9c7e5a&"
import script from "./voteIcon.vue?vue&type=script&lang=ts&"
export * from "./voteIcon.vue?vue&type=script&lang=ts&"
import style0 from "./voteIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports